import styles from "../LightHouse.module.css"
import { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import HeaderMain from "../component/HeaderMain";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UnseContext } from "../context/UnseContext";
import { usePoint } from "../context/PointContext";

function FortuneInfo({ setFortuneList, menuList, Loading, Constellation, cards, setAgreePrivacyTab }) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    let memberId = localStorage.getItem("lighthouse_memberId");
    const socialLoggedIn = localStorage.getItem("lighthouse_socialLoggedIn");
    const isLoggedIn = socialLoggedIn === 'true';
    const [data, setData] = useState({});
    const [myNameCheck, setMyNameCheck] = useState(true);
    const [partnerNameCheck, setPartnerNameCheck] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const isValidMember = memberId && memberId !== "null";
    const inputRef = useRef({});
    const { orderId } = useParams();
    const { setUnseData } = useContext(UnseContext);
    const { point, showPointInsufficient, updatePointAfterUse } = usePoint();
    const navigate = useNavigate();
    const orderIdNum = Number(orderId);
    const item = cards.find(card => Number(card.ORDER_ID) === orderIdNum);
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;
    const [isLocked, setIsLocked] = useState(false);
    const requiredPoint = item?.POINT_PRICE || 0;

    const [AGREE_PRIVACY, setAgreePrivacy] = useState(() => {
        try {
            const parsed = memberId ? JSON.parse(memberId) : null;
            return parsed != null; 
        } catch (e) {
            return false;
        }
    });



    // ★ 캐시 상태 체크 (포인트 차감 없이 확인만)
    function checkCacheStatus(unseId, memberId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${API_BASE_URL}/getUnseWithPersona`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify({
                    "unse_id": unseId,
                    "member_id": memberId,
                    "site_code": siteCode,
                    "check_only": true
                }),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    if (res.code != "0") {
                        return reject(new Error(res.msg || "캐시 확인 실패"));
                    }
                    resolve(res); // { cached: true/false, unse_log_id?, point_required? }
                },
                error: function (xhr, status, err) {
                    console.error("캐시 체크 에러:", err);
                    reject(err);
                },
            });
        });
    }

    // ★ 운세 결과값 가져오기(gpt) - Promise 반환 / 로딩·페이지이동 없음
    function getUnse(unseId, memberId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${API_BASE_URL}/getUnseWithPersona`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify({ "unse_id": unseId, "member_id": memberId, "site_code": siteCode }),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    // 포인트 부족 처리 (code: '6')
                    if (res.code === '6') {
                        showPointInsufficient(res.required_point, res.current_point);
                        return reject(new Error('INSUFFICIENT_POINT'));
                    }
                    if (res.code != "0") {
                        alert(res.msg);
                        return reject(new Error(res.msg || "운세 조회 실패"));
                    }
                    // 포인트 사용 후 컨텍스트 업데이트
                    if (res.point_used && res.point_used > 0) {
                        updatePointAfterUse(res.point_used);
                    }
                    // console.log("운세 응답:", res);
                    resolve(res); // 여기서 데이터만 넘김
                },
                error: function (xhr, status, err) {
                    console.error("운세 에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                    reject(err);
                },
            });
        });
    }

    // ★ 회원 정보 저장(procMember)도 Promise로 래핑
    function procMember(form) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${API_BASE_URL}/procMember`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(form),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    if (res.code != "0") {
                        alert(res.msg);
                        return reject(new Error(res.msg || "회원정보 저장 실패"));
                    }
                    // console.log("회원 저장 응답:", res);
                    localStorage.setItem("lighthouse_memberId", res.member_id);
                    resolve(res.member_id); // 새 member_id 반환
                },
                error: function (xhr, status, err) {
                    console.error("회원 저장 에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                    reject(err);
                },
            });
        });
    }

    // 첫 마운트 유저 정보 가져오기
    useEffect(() => {
        $.ajax({
            url: `${API_BASE_URL}/postMember`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                "member_id": memberId, "site_code": siteCode
            }),
            cache: false,
            headers: {
                APIKEY: APIKEY,
            },
            success: function (res) {
                if (res.code != "0") {
                    alert(res.msg); return false;
                }
                setData(res.memberRow);
                // console.log("postMember 응답:", res);
            },
            error: function (xhr, status, err) {
                console.error("postMember 에러:", err);
                // console.log("상태:", xhr.status, "응답:", xhr.responseText);
            },
        });
        localStorage.setItem("lighthouse_memberId", memberId);

    }, []);

    const [form, setForm] = useState({
        //내정보
        NAME: '',
        SEX: '남자',
        BIRTHDAY: '',
        BIRTHDATE: '',
        CALENDAR_TYPE: '양력',
        member_id: '',
        site_code: siteCode
    });

    // 해당 월의 일수 계산 (윤년 포함)
    const getDaysInMonth = (year, month) => {
        if (!year || !month) return 31;
        return new Date(parseInt(year), parseInt(month), 0).getDate();
    };

    // 현재 선택된 년/월에 따른 최대 일수
    const birthdayParts = form.BIRTHDAY ? form.BIRTHDAY.split('.') : ['', '', ''];
    const maxDays = getDaysInMonth(birthdayParts[0], birthdayParts[1]);

    //첫 통신에 데이터가 없는경우 데이터 저장
    useEffect(() => {
        setForm(prev => ({
            ...prev,
            //내정보
            NAME: data.NAME ?? '',
            SEX: data.SEX ?? '남자',
            BIRTHDAY: data.BIRTHDAY ?? '',
            BIRTHDATE: data.BIRTHDATE ?? '',
            CALENDAR_TYPE: data.CALENDAR_TYPE ?? '양력',
            member_id: memberId ?? '',
            site_code: siteCode
        }));
    }, [data, memberId]);

    //input 정규식
    const handleChange = (e) => {
        const { id, value } = e.target;

        if (id === "NAME" || id === "PARTNER_NAME") {
            let newValue = value;
            newValue = newValue.replace(/[A-Za-z0-9]/g, "");

            if (newValue.length > 6) {
                newValue = newValue.slice(0, 6);
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));

            const hasChoseong = /[ㄱ-ㅎ]/.test(newValue);
            const isValid = !!newValue && !hasChoseong;

            if (id === "NAME") {
                setMyNameCheck(isValid);
            } else if (id === "PARTNER_NAME") {
                setPartnerNameCheck(isValid);
            }
            return;
        }

        if (id === "BIRTHDAY" || id === "PARTNER_BIRTHDAY") {
            let digits = value.replace(/[^0-9]/g, "");
            digits = digits.slice(0, 8);

            let newValue = "";
            if (digits.length <= 4) {
                newValue = digits;
            } else if (digits.length <= 6) {
                newValue = `${digits.slice(0, 4)}.${digits.slice(4)}`;
            } else {
                newValue = `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));
            return;
        }

        if (id === "BIRTHDATE" || id === "PARTNER_BIRTHDATE") {
            let digits = value.replace(/[^0-9]/g, "");
            digits = digits.slice(0, 4);

            let newValue = "";
            if (digits.length <= 2) {
                newValue = digits;
            } else {
                newValue = `${digits.slice(0, 2)}:${digits.slice(2)}`;
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));
            return;
        }

        setForm((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleClear = (id) => {
        setForm((prev) => ({
            ...prev,
            [id]: "",
        }));
    };

    const handleRadio = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleUnknownBirth = (e) => {
        const checked = e.target.checked;
        setForm(prev => ({
            ...prev,
            BIRTHDATE: checked ? '시간 모름' : '',
        }));
    };

    const setInputRef = (name) => (el) => {
        inputRef.current[name] = el;
    };

    // ★ 사용자 정보 보내기 + 운세 + 광고까지 한 번에 처리
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.NAME == "" || myNameCheck == false) {
            alert('이름을 확인해주세요.');
            inputRef.current['NAME']?.focus();
            return;
        }
        if (form.SEX == "") {
            alert('성별을 체크해주세요.');
            inputRef.current['SEX']?.focus();
            return;
        }
        if (form.BIRTHDAY == "" || form.BIRTHDAY.length < 10) {
            alert('생년월일을 확인해주세요.');
            inputRef.current['BIRTHDAY']?.focus();
            return;
        }
        if (form.CALENDAR_TYPE == "") {
            alert('양력/음력을 선택해주세요.');
            inputRef.current['CALENDAR_TYPE']?.focus();
            return;
        }
        if (form.BIRTHDATE == "" || form.BIRTHDATE.length < 5) {
            alert('태어난 시간을 확인해주세요.');
            inputRef.current['BIRTHDATE']?.focus();
            return;
        }
        if (!AGREE_PRIVACY) {
            alert('개인정보 수집 / 이용 동의에 동의해주세요');
            return;
        }

        // 운세 결과 보기는 로그인 필수 (이중 체크)
        if (orderId !== undefined && !isLoggedIn) {
            alert('운세를 보려면 로그인이 필요합니다.');
            return;
        }

        try {
            // 1) 회원 정보 저장
            const newMemberId = await procMember(form);
            memberId = newMemberId; // 로컬 변수 업데이트

            // 운세 카드 없이 단순 정보 저장만 한 경우
            if (orderId === undefined) {
                alert('회원정보가 저장되었습니다.');
                window.location.href = "/lighthouse";
                return;
            }

            if (isLocked) return;

            setIsLocked(true);

            // 2) 캐시 상태 확인 (포인트 차감 없이)
            let isCached = false;
            try {
                const cacheCheck = await checkCacheStatus(orderId, newMemberId);
                isCached = cacheCheck.cached === true;
            } catch (err) {
                console.error("캐시 체크 실패, 새로 생성으로 진행:", err);
                isCached = false;
            }

            // 3) 캐시가 없고 포인트가 필요한 경우에만 confirm 표시
            if (!isCached && requiredPoint > 0) {
                // 포인트 부족 체크
                if (point < requiredPoint) {
                    setIsLocked(false);
                    showPointInsufficient(requiredPoint, point);
                    return;
                }

                // 포인트 사용 확인
                const confirmed = window.confirm(
                    `이 운세를 보려면 ${requiredPoint}P가 차감됩니다.\n\n` +
                    `현재 포인트: ${point}P\n` +
                    `차감 후 잔여: ${point - requiredPoint}P\n\n` +
                    `사용하시겠습니까?`
                );
                if (!confirmed) {
                    setIsLocked(false);
                    return;
                }
            }

            // 4) 운세 요청을 백그라운드에서 먼저 시작
            const unsePromise = getUnse(orderId, newMemberId);

            // 5) 그 사이에 Flutter 리워드 광고 표시
            let adResult = { success: true }; // 브라우저 테스트용 기본값

            // 광고 스킵 IP 목록
            const SKIP_AD_IPS = ['119.65.230.78'];
            let clientIp = null;

            try {
                // IP 확인
                const ipResponse = await fetch('https://api.ipify.org?format=json');
                const ipData = await ipResponse.json();
                clientIp = ipData.ip;
            } catch (ipErr) {
                console.log("IP 확인 실패:", ipErr);
            }

            try {
                // 특정 IP는 광고 스킵
                if (clientIp && SKIP_AD_IPS.includes(clientIp)) {
                    console.log("광고 스킵 IP:", clientIp);
                    adResult = { success: true };
                } else if (
                    window.flutter_inappwebview &&
                    typeof window.flutter_inappwebview.callHandler === "function"
                ) {
                    // Flutter 쪽에서 { success: true/false } 형태로 내려준다고 가정
                    adResult = await window.flutter_inappwebview.callHandler("showRewardAd");
                } else {
                    console.log("flutter_inappwebview 없음 - 브라우저에서 광고 없이 진행");
                }
            } catch (adErr) {
                console.error("광고 호출 중 에러:", adErr);
                alert(adErr);
                // 여기서 실패를 광고 미시청으로 처리할지, 그냥 통과시킬지는 정책에 따라
                // 일단은 실패 = 광고 미시청으로 보려면 success=false로 두면 됨
                adResult = { success: false };
            }

            // 5-1) 광고를 끝까지 안 본 경우 → 운세 보여주지 않고 메인으로
            if (!adResult || adResult.success !== true) {
                alert('광고 시청을 끝까지 해주세요.');
                // 백그라운드로 돌고 있던 운세 Promise는 결과를 버리기만 하면 됨
                unsePromise
                    .then(() => { })
                    .catch(() => { });
                // 메인으로 이동
                window.location.href = "/lightHouse";
                return;
            }

            // 6) 광고가 끝난 시점부터 로딩 화면 ON
            setIsLoading(true);

            // 7) 운세 API 결과 대기 (이미 끝났으면 바로 통과)
            const res = await unsePromise;

            // 8) 운세 데이터 세팅 + 이동
            localStorage.setItem("lighthouse_unseLogId", res.unse_log_id);
            setUnseData(res);

            // 필요하다면 리스트 닫기
            if (setFortuneList) {
                setFortuneList(false);
            }

            navigate("/lightHouse/UnseResult");
        } catch (err) {
            console.error("전체 처리 중 에러:", err);
            // 포인트 부족 에러는 팝업으로 이미 처리됨
            if (err.message !== 'INSUFFICIENT_POINT') {
                alert("처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
            }
        } finally {
            setIsLoading(false);
            setIsLocked(false);
        }
    };

    if (isLoading) {
        return <Loading Constellation={Constellation} />;
    }

    // 운세 보기 시 로그인 체크 (orderId가 있을 때)
    if (orderId !== undefined && !isLoggedIn) {
        return (
            <div className="FortuneInfoPage_inner">
                <div className={`FortuneInfoContent ${styles.FortuneInfoContent_lightHouse} ${styles.infoMessageBox}`}>
                    <div className={styles.infoMessageIcon}>🔐</div>
                    <h2 className={styles.infoMessageTitle}>로그인이 필요합니다</h2>
                    <p className={styles.infoMessageDesc}>
                        운세를 보려면 로그인이 필요합니다.<br />
                        메뉴에서 네이버 또는 카카오로 로그인해주세요.
                    </p>
                    <button onClick={() => navigate('/lighthouse')} className={styles.infoMessageBtn}>
                        메인으로 돌아가기
                    </button>
                </div>
            </div>
        );
    }

    // 운세 보기 시 포인트 체크 (orderId가 있고 포인트가 필요할 때)
    if (orderId !== undefined && requiredPoint > 0 && point < requiredPoint) {
        return (
            <div className="FortuneInfoPage_inner">
                <div className={`FortuneInfoContent ${styles.FortuneInfoContent_lightHouse} ${styles.infoMessageBox}`}>
                    <div className={styles.infoMessageIcon}>💰</div>
                    <h2 className={styles.infoMessageTitle}>포인트가 부족합니다</h2>
                    <p className={styles.infoMessageDesc}>
                        이 운세를 보려면 {requiredPoint}P가 필요합니다.
                    </p>
                    <div className={styles.pointCompareBox}>
                        <div className={styles.pointCompareItem}>
                            <div className={styles.pointCompareLabel}>내 포인트</div>
                            <div className={`${styles.pointCompareValue} ${styles.current}`}>{point}P</div>
                        </div>
                        <div className={styles.pointCompareItem}>
                            <div className={styles.pointCompareLabel}>필요 포인트</div>
                            <div className={`${styles.pointCompareValue} ${styles.required}`}>{requiredPoint}P</div>
                        </div>
                    </div>
                    <p className={styles.infoMessageDesc}>
                        매일 출석체크로 포인트를 모아보세요!
                    </p>
                    <button onClick={() => navigate('/lighthouse')} className={styles.infoMessageBtn}>
                        메인으로 돌아가기
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="FortuneInfoPage_inner">
            <div className={`FortuneInfoContent ${styles.FortuneInfoContent_lightHouse}`}>
                <div className="infoTItleBox">
                    <h2 className="title">운세 정보 입력</h2>
                    {
                        item == undefined ? null : <span>{`(${item?.TITLE})`}</span>
                    }
                </div>
                <p className="subTitle">
                    당신만의 운세를 정확히 보기 위해 운세 정보를 입력해주세요.<br />
                    (한 번만 입력하시면 이 후 자동으로 적용됩니다.)
                </p>

                <form onSubmit={handleSubmit}>
                    {/* 내 정보 */}
                    <section>
                        {/* 이름 */}
                        <div id="NAME" className="nameBox">
                            <label htmlFor="NAME" className="infoTitle">나의 이름</label>
                            <div className="nameInput">
                                <input
                                    id="NAME"
                                    type="text"
                                    value={form.NAME}
                                    onChange={handleChange}
                                    placeholder="이름을 입력해주세요."
                                    disabled={isLocked}
                                    ref={setInputRef('NAME')}
                                />
                                {
                                    form.NAME && (
                                        <button className="cleanBtn" onClick={() => handleClear("NAME")}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                            {
                                myNameCheck
                                    ? <span className="notice">한글 최대 6자</span>
                                    : <span className="nameCheck">정확한 이름을 입력해주세요.</span>
                            }
                        </div>

                        {/* 성별 */}
                        <div style={{ marginBottom: '5px' }}>
                            <span className="infoTitle">나의 성별</span>
                            <div className="sexBox">
                                <label htmlFor="M">
                                    <input
                                        id="M"
                                        name="SEX"
                                        type="radio"
                                        value="남자"
                                        disabled={isLocked}
                                        checked={form.SEX === "남자"}
                                        onChange={handleRadio}
                                    />
                                    <span>남자</span>
                                </label>
                                <label htmlFor="F">
                                    <input
                                        id="F"
                                        name="SEX"
                                        type="radio"
                                        value="여자"
                                        disabled={isLocked}
                                        checked={form.SEX === "여자"}
                                        onChange={handleRadio}
                                    />
                                    <span>여자</span>
                                </label>
                            </div>
                        </div>

                        {/* 생년월일 */}
                        <div style={{ marginBottom: '20px' }}>
                            <label className="infoTitle">나의 생년월일</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <select
                                    value={form.BIRTHDAY ? form.BIRTHDAY.split('.')[0] : ''}
                                    onChange={(e) => {
                                        const parts = form.BIRTHDAY ? form.BIRTHDAY.split('.') : ['', '', ''];
                                        parts[0] = e.target.value;
                                        // 년도 변경 시 일자 유효성 검사
                                        if (parts[1] && parts[2]) {
                                            const newMaxDays = getDaysInMonth(e.target.value, parts[1]);
                                            if (parseInt(parts[2]) > newMaxDays) {
                                                parts[2] = String(newMaxDays).padStart(2, '0');
                                            }
                                        }
                                        setForm(prev => ({ ...prev, BIRTHDAY: parts.join('.') }));
                                    }}
                                    disabled={isLocked}
                                    style={{ flex: 1, padding: '12px 6px', borderRadius: '8px', border: 'none', background: '#fff', color: '#333', fontSize: '13px', minWidth: 0 }}
                                >
                                    <option value="">년</option>
                                    {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                                <select
                                    value={form.BIRTHDAY ? form.BIRTHDAY.split('.')[1] : ''}
                                    onChange={(e) => {
                                        const parts = form.BIRTHDAY ? form.BIRTHDAY.split('.') : ['', '', ''];
                                        parts[1] = e.target.value;
                                        // 월 변경 시 일자 유효성 검사
                                        if (parts[0] && parts[2]) {
                                            const newMaxDays = getDaysInMonth(parts[0], e.target.value);
                                            if (parseInt(parts[2]) > newMaxDays) {
                                                parts[2] = String(newMaxDays).padStart(2, '0');
                                            }
                                        }
                                        setForm(prev => ({ ...prev, BIRTHDAY: parts.join('.') }));
                                    }}
                                    disabled={isLocked}
                                    style={{ width: '60px', padding: '12px 6px', borderRadius: '8px', border: 'none', background: '#fff', color: '#333', fontSize: '13px', flexShrink: 0 }}
                                >
                                    <option value="">월</option>
                                    {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')).map(month => (
                                        <option key={month} value={month}>{parseInt(month)}</option>
                                    ))}
                                </select>
                                <select
                                    value={form.BIRTHDAY ? form.BIRTHDAY.split('.')[2] : ''}
                                    onChange={(e) => {
                                        const parts = form.BIRTHDAY ? form.BIRTHDAY.split('.') : ['', '', ''];
                                        parts[2] = e.target.value;
                                        setForm(prev => ({ ...prev, BIRTHDAY: parts.join('.') }));
                                    }}
                                    disabled={isLocked}
                                    style={{ width: '60px', padding: '12px 6px', borderRadius: '8px', border: 'none', background: '#fff', color: '#333', fontSize: '13px', flexShrink: 0 }}
                                >
                                    <option value="">일</option>
                                    {Array.from({ length: maxDays }, (_, i) => String(i + 1).padStart(2, '0')).map(day => (
                                        <option key={day} value={day}>{parseInt(day)}</option>
                                    ))}
                                </select>
                                <div style={{ display: 'flex', gap: '8px', marginLeft: '4px', flexShrink: 0 }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#fff', cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="CALENDAR_TYPE"
                                            value="양력"
                                            checked={form.CALENDAR_TYPE === "양력"}
                                            disabled={isLocked}
                                            onChange={handleRadio}
                                            style={{ margin: 0 }}
                                        />
                                        <span>양력</span>
                                    </label>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#fff', cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="CALENDAR_TYPE"
                                            value="음력"
                                            checked={form.CALENDAR_TYPE === "음력"}
                                            disabled={isLocked}
                                            onChange={handleRadio}
                                            style={{ margin: 0 }}
                                        />
                                        <span>음력</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* 태어난 시간 */}
                        <div style={{ marginBottom: '25px' }}>
                            <label className="infoTitle">태어난 시간</label>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <select
                                    value={
                                        form.BIRTHDATE && form.BIRTHDATE !== '시간 모름' && form.BIRTHDATE.includes(':')
                                            ? form.BIRTHDATE.split(':')[0]
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const newHour = e.target.value;

                                        setForm((prev) => {
                                            if (prev.BIRTHDATE === '시간 모름') return prev;

                                            const [prevHour = '', prevMin = ''] =
                                                prev.BIRTHDATE && prev.BIRTHDATE.includes(':')
                                                    ? prev.BIRTHDATE.split(':')
                                                    : ['', ''];

                                            // ✅ 시만 선택해도 'HH:' 형태로 저장하여 유지
                                            const next = `${newHour}:${prevMin || ''}`;
                                            return { ...prev, BIRTHDATE: next === ':' ? '' : next };
                                        });
                                    }}
                                    disabled={isLocked || form.BIRTHDATE === '시간 모름'}
                                    style={{ flex: 1, padding: '12px 6px', borderRadius: '8px', border: 'none', background: '#fff', color: '#333', fontSize: '13px', minWidth: 0 }}
                                >
                                    <option value="">시</option>
                                    {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')).map((hour) => (
                                        <option key={hour} value={hour}>{hour}시</option>
                                    ))}
                                </select>

                                <select
                                    value={
                                        form.BIRTHDATE && form.BIRTHDATE !== '시간 모름' && form.BIRTHDATE.includes(':')
                                            ? form.BIRTHDATE.split(':')[1]
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const newMin = e.target.value;

                                        setForm((prev) => {
                                            if (prev.BIRTHDATE === '시간 모름') return prev;

                                            const [prevHour = '', prevMin = ''] =
                                                prev.BIRTHDATE && prev.BIRTHDATE.includes(':')
                                                    ? prev.BIRTHDATE.split(':')
                                                    : ['', ''];

                                            // ✅ 분만 선택해도 'HH:MM' 또는 ':MM' 형태로 저장
                                            const next = `${prevHour || ''}:${newMin}`;
                                            return { ...prev, BIRTHDATE: next === ':' ? '' : next };
                                        });
                                    }}
                                    disabled={isLocked || form.BIRTHDATE === '시간 모름'}
                                    style={{ flex: 1, padding: '12px 6px', borderRadius: '8px', border: 'none', background: '#fff', color: '#333', fontSize: '13px', minWidth: 0 }}
                                >
                                    <option value="">분</option>
                                    {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')).map((min) => (
                                        <option key={min} value={min}>{min}분</option>
                                    ))}
                                </select>

                                <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#fff', cursor: 'pointer', marginLeft: '4px', flexShrink: 0 }}>
                                    <input
                                        type="checkbox"
                                        checked={form.BIRTHDATE === '시간 모름'}
                                        onChange={handleUnknownBirth}
                                        disabled={isLocked}
                                        style={{ margin: 0 }}
                                    />
                                    <span>시간 모름</span>
                                </label>
                            </div>
                        </div>
                    </section>

                    {/* <section>
                        <h4 className="partnerTitle">상대 정보 입력</h4>

                        <div className="nameBox">
                            <label htmlFor="PARTNER_NAME" className="infoTitle">상대방의 이름</label>
                            <div className="nameInput">
                                <input
                                    id="PARTNER_NAME"
                                    type="text"
                                    value={form.PARTNER_NAME}
                                    onChange={handleChange}
                                    placeholder="이름을 입력해주세요."
                                />
                                {
                                    form.PARTNER_NAME && (
                                        <button className="cleanBtn" onClick={(() => { handleClear("PARTNER_NAME") })}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                            {
                                partnerNameCheck
                                    ? <span className="notice">한글 최대 6자</span>
                                    : <span className="nameCheck">정확한 이름을 입력해주세요.</span>
                            }
                        </div>

                        <div>
                            <span className="infoTitle">상대 성별</span>
                            <div className="sexBox">
                                <label htmlFor="PARTNER_M">
                                    <input
                                        id="PARTNER_M"
                                        name="PARTNER_SEX"
                                        type="radio"
                                        value="남자"
                                        checked={form.PARTNER_SEX === "남자"}
                                        onChange={handleRadio}
                                    />
                                    <span>남자</span>
                                </label>
                                <label htmlFor="PARTNER_F">
                                    <input
                                        id="PARTNER_F"
                                        name="PARTNER_SEX"
                                        type="radio"
                                        value="여자"
                                        checked={form.PARTNER_SEX === "여자"}
                                        onChange={handleRadio}
                                    />
                                    <span>여자</span>
                                </label>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="PARTNER_BIRTHDAY" className="infoTitle">상대방의 생년월일</label>
                            <div className="absoluteBox">
                                <input id="PARTNER_BIRTHDAY" type="text" maxLength={10} value={form.PARTNER_BIRTHDAY} onChange={handleChange} placeholder="1900.01.01" />
                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="radio"
                                            name="PARTNER_CALENDAR_TYPE"
                                            value="양력"
                                            checked={form.PARTNER_CALENDAR_TYPE === "양력"}
                                            onChange={handleRadio}
                                        />
                                        <span>양력</span>
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="PARTNER_CALENDAR_TYPE"
                                            value="음력"
                                            checked={form.PARTNER_CALENDAR_TYPE === "음력"}
                                            onChange={handleRadio}
                                        />
                                        <span>음력</span>
                                    </label>
                                </div>
                                {
                                    form.PARTNER_BIRTHDAY && (
                                        <button className="cleanBtn" onClick={(() => { handleClear("PARTNER_BIRTHDAY") })}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                        </div>

                        <div>
                            <label htmlFor="PARTNER_BIRTHDATE" className="infoTitle">상대방 태어난 시간</label>
                            <div className="absoluteBox">
                                <input
                                    id="PARTNER_BIRTHDATE"
                                    name="PARTNER_BIRTHDATE"
                                    type="text"
                                    maxLength={5}
                                    value={form.PARTNER_BIRTHDATE === '시간 모름' ? '' : (form.PARTNER_BIRTHDATE || '')}
                                    onChange={handleChange}
                                    placeholder="12:00"
                                    disabled={form.PARTNER_BIRTHDATE === '시간 모름'}
                                />

                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={form.PARTNER_BIRTHDATE === '시간 모름'}
                                            onChange={handlePartnerUnknownBirth}
                                        />
                                        <span>시간 모름</span>
                                    </label>
                                </div>

                                {form.PARTNER_BIRTHDATE &&
                                    form.PARTNER_BIRTHDATE !== '시간 모름' && (
                                        <button
                                            type="button"
                                            className="cleanBtn"
                                            onClick={() => handleClear('PARTNER_BIRTHDATE')}
                                        >
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )}
                            </div>
                        </div>

                    </section> */}

                    <div className="personalInfoCollection">
                        <label htmlFor="agreePrivacy">
                            <input
                                id="agreePrivacy"
                                type="checkbox"
                                name="agreePrivacy"
                                disabled={isLocked}
                                checked={AGREE_PRIVACY}
                                onChange={(e) => setAgreePrivacy(e.target.checked)}
                            />
                            <span>개인정보 수집 / 이용 동의</span>
                        </label>
                        {/* <button type="button" className="viewBtn" onClick={(() => {
                                setAgreePrivacyTab(true);
                                if (agreePrivacyTab) {
                                    document.documentElement.classList.add("scrollNone");
                                } else {
                                    document.documentElement.classList.remove("scrollNone");
                                }
                            })}>약관보기</button> */}
                        <button type="button" className={`viewBtn ${styles.viewBtn_daetong}`} onClick={(()=>{setAgreePrivacyTab(true)})}>약관보기</button>
                    </div>
                    {/* 포인트 필요 안내 */}
                    {orderId !== undefined && item?.POINT_PRICE > 0 && (
                        <div className={styles.pointRequiredBox}>
                            <span className={styles.pointRequiredLabel}>필요 포인트</span>
                            <span className={styles.pointRequiredValue}>{item.POINT_PRICE}P</span>
                        </div>
                    )}
                    {
                        orderId !== undefined && isValidMember
                            ? <button type="submit" className="submitBtn" disabled={isLocked}>결과보기</button>
                            : <button type="submit" className="submitBtn" disabled={isLocked}>저장하기</button>
                    }

                    {/* <div className={agreePrivacyTab ? "agreePrivacyPage active" : "agreePrivacyPage"}>
                            <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} agreePrivacyTab={agreePrivacyTab}/>
                            <AgreePrivacy></AgreePrivacy>
                        </div> */}
                </form>
            </div>
        </div>
    )
}
export default FortuneInfo;





